import { profileRoute } from '../Profile/route.const'

export const accountPaymentRoute = () => `${profileRoute()}/payment`
